import { NgClass } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { LogoModule, ThemingService } from '@michelin/theme';
import { AppService } from '../app.service';
import { AuthenticationWrapperService } from '../services/authentication-wrapper.service';

@Component({
  selector: 'mic-app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  imports: [MatButton, LogoModule, NgClass]
})
export class AuthenticationComponent {
  private readonly appService = inject(AppService);
  private readonly themingService = inject(ThemingService);
  private readonly authWrapperService = inject(AuthenticationWrapperService);

  hide = true;
  image = true;
  @HostBinding('class') className = this.themingService.theme.className;
  isUserLogin: boolean;

  login(): void {
    this.authWrapperService.onLoginRequired$.next();
  }
  onSubmit() {
    this.appService.logStatusChange(true);
  }
}
